const APIS = {
  TEMPLATE:"/templateservice/api/template/",
  USER:"/usermanagementservice/api/user/",
  TEMPLATE_RESET:"templateservice/api/template/overall-reset/",
  SETTINGS:"/projectsettingsservice/api/column-definition/Orders/",
  COLUMN_DEFINITION_RESET:"/projectsettingsservice/api/column-definition/",
};

export default APIS;
